import { render, staticRenderFns } from "./RemStudentFromClassBtn.vue?vue&type=template&id=f59e472e&"
import script from "./RemStudentFromClassBtn.vue?vue&type=script&lang=js&"
export * from "./RemStudentFromClassBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports